export default {
	props: {
		id: String,
		attrKey: String,
		value: String,
		dateFormat: {
			type: String,
			default: 'yy-mm-dd'
		},
		disabled: String
	},
	mounted: function () {
		let language = this.$store.getters.getLanguage ?  this.$store.getters.getLanguage.toLowerCase() : 'cs';
		let picker = $(this.$el).find('.datepicker');
		picker.datepicker(this.getOptions())
		picker.datepicker('option', $.datepicker.regional[language]);
		$('#ui-datepicker-div').hide();
	},
	beforeDestroy: function () {
		$(this.$el).find('.datepicker').datepicker('hide').datepicker('destroy')
	},
	methods: {
		getOptions() {
			const self = this
			return {
				dateFormat: this.dateFormat,
				onSelect: function (date) {
					self.emitUpdateDateEvent(date)
				}
			}
		},
		emitUpdateDateEvent(date) {
			this.$emit('update-date', { date: date, attrKey: this.attrKey })
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/date-picker.js